/* eslint-disable @typescript-eslint/naming-convention */ // Base API fields are snake_case
import { BilberryBooking, BilberryReservation, PaymentInfo } from '@repo/types';

// Mirror of usePayment's BilberryBooking → PaymentInfo mapping in createReservationThroughBilberryBase.
export function paymentInfoFromBooking(
    booking: BilberryBooking,
    reservation: BilberryReservation,
): PaymentInfo {
    return {
        payment_gateway: booking.payment_gateway as PaymentInfo['payment_gateway'],
        payment_id: booking.payment_id,
        reference: booking.id.toString(),
        checkout_key: booking.checkout_key ?? undefined,
        reservation,
        booking,
    };
}

// Mirror of usePayment's "go straight to receipt" predicate: a 0-NOK / fully covered booking has no
// payment id and is already paid, so it skips the gateway instead of mounting a payment element.
export function shouldSkipPayment(info: PaymentInfo, booking: BilberryBooking): boolean {
    return (
        (!info.payment_id && info.reference !== null && !booking.stripe_key) ||
        (Boolean(booking.paid_at) && !info.payment_id && !info.checkout_key)
    );
}
